// extracted by mini-css-extract-plugin
export var container = "lp_pdp-module--container--64c8e";
export var content = "lp_pdp-module--content--914bb";
export var lpBlocks = "lp_pdp-module--lp-blocks--34a20";
export var productContainer = "lp_pdp-module--product-container--ebc85";
export var productInfo = "lp_pdp-module--product-info--59ebf";